import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class FormStateService {
  private formDirtyKey = "formDirty";

  constructor() {}

  // Set the form as dirty in localStorage
  setFormDirty(): void {
    localStorage.setItem(this.formDirtyKey, "true");
  }

  // Clear the form dirty flag in localStorage
  clearFormDirty(): void {
    localStorage.removeItem(this.formDirtyKey);
  }

  // Check if the form is dirty
  isFormDirty(): boolean {
    return localStorage.getItem(this.formDirtyKey) === "true";
  }
}
